<template>
    <div id="step3">
        <h3><img src=".././assets/images/step3-title.svg"> 仕上がりサイズを入力する</h3>
        <input_size style="margin-bottom: 1rem;" v-if="(group2_1 || group1_1) && group2_1 !== 'ベッドスプレッド' && group1_1 !=='クッション'" />
        <span v-if="group1_1 === 'カーテン'">
            <curtain_drape v-if="item_data && item_data['ドレープ/レース'] === 'ドレープ'"/>
            <curtain_lace  v-else-if="item_data && item_data['ドレープ/レース'] === 'レース'" />
        </span>
        <deco_blance v-if="$store.state.step2_data.style_selected1_name === 'デコ付きバランス'" />
        <multicover v-if="$store.state.step2_data.style_selected1_name === 'マルチカバー2サイドデコ'"/>
        <rollscreen v-if="group2_1 === 'ロールスクリーン＆ローマンシェード'"/>
        <bed_spread v-if="group2_1 === 'ベッドスプレッド'"/>
        <cushion v-if="group1_1 ==='クッション'"/>
        <b-row>
            <b-col cols="7" class="" style="padding-top: 5px;">
                <span  class="hidden-xs" style="font-size: 0.7rem">&nbsp;&nbsp;現在の金額</span>
                <b-row class="sum_price hidden-xs" v-if="priceStyle.fontSize==='1.6rem'">
                    <b-col v-bind:style="priceStyle" cols="7" class="price_area" style="text-align: right;">{{price}}&nbsp;</b-col>
                    <b-col cols="5" class="price_end">&nbsp;円(税抜)</b-col>
                </b-row>
                <b-row class="sum_price hidden-xs" v-else>
                    <b-col v-bind:style="priceStyle" cols="12" class="price_area" style="text-align: center;">{{price}}</b-col>
                </b-row>
            </b-col>
            <b-col cols="5">
        <span v-if="
        $store.state.step2_data.style_selected1_id !== '' &&
        $store.state.step2_data.style_selected2_id === '' &&
        group1_1 &&
        $store.state.xlsx_data.style_data[$store.state.step2_data.style_selected1_id].urls !== undefined &&
        $store.state.xlsx_data.style_data[$store.state.step2_data.style_selected1_id].urls !== ''
        ">
            <div class="styleImageUrlButton">
                <button class="btn btn-warning" v-on:click="styleImaging($store.state.step2_data.style_selected1_id)">
                    スタイルイメージ<br>仕様確認
                </button>
            </div>
        </span>
                <span v-else-if="
        $store.state.step2_data.style_selected2_id !== '' &&
        group2_1 &&
        $store.state.xlsx_data.style_data[$store.state.step2_data.style_selected2_id].urls !== undefined
        ">
            <div class="styleImageUrlButton">
                <button class="btn btn-warning" v-on:click="styleImaging($store.state.step2_data.style_selected2_id)">
                    スタイルイメージ<br>仕様確認
                </button>
            </div>
        </span>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    //import select_item from '../assets/script/mixins/mixin'
    import input_size from './step3_parts/00_input_size.vue'
    import curtain_drape from './step3_parts/01_curtain_drape.vue'
    import curtain_lace  from './step3_parts/02_curtain_lace.vue'
    import rollscreen  from './step3_parts/03_rollscreen.vue'
    import bed_spread  from './step3_parts/04_bed_spread.vue'
    import multicover  from './step3_parts/05_multicover.vue'
    import cushion  from './step3_parts/06_cushion.vue'
    import deco_blance  from './step3_parts/07_deco_balance.vue'

    export default {
        name: "STEP3",
        components: {
            input_size,curtain_drape,curtain_lace,rollscreen,bed_spread,multicover,cushion,deco_blance
        },
        data() {
            return {
                priceStyle:{fontSize:'1.6rem'},
            }
        },
        computed: {
            group1_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected1_id !== ''){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1
                    }
                    return ''
                },
            },
            group2_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group1
                    }
                    return ''
                },
            },
            group2: {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }else{
                        return ''
                    }

                },
            },
            style_selected1_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_name
                },
            },
            style_selected2_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_name
                },
            },
            item_data: {
                get: function () {
                    if(
                        this.$store.state.step1_data.item_number &&
                        this.$store.state.xlsx_data.item_data &&
                        typeof(this.$store.state.xlsx_data.item_data['SH'+this.$store.state.step1_data.item_number]) !=='undefined'
                    ){
                        return this.$store.state.xlsx_data.item_data['SH'+this.$store.state.step1_data.item_number]
                    }
                    return ''
                },
            },
            is_show: {
                get:function(){
                    if(this.$store.state.step2_data.style_selected1_id !== '' ||  this.$store.state.step2_data.style_selected2_id !== ''){
                        return true
                    }
                    return false
                }
            },
            price: {
                get: function () {
                    const step2_data = this.$store.state.step2_data
                    const step3_data = this.$store.state.step3_data
                    const price = this.$store.state.price_data.price

                    const price_ura = this.$store.state.price_data.price_ura
                    const price_add = this.$store.state.price_data.price_add
                    const price_atomaku = this.$store.state.price_data.price_atomaku
                    let group2 = ''
                    if(this.$store.state.step2_data.style_selected2_id){
                        group2 = this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }

                    if(this.$store.state.step2_data.style_selected1_id === '' &&  this.$store.state.step2_data.style_selected2_id === ''){
                        total_price = '-'
                        this.$store.commit('updatePriceData', {name: 'total_price', value: total_price})
                        return total_price
                    }
                    if(group2 ==='ローマンシェード ツイン' && price_atomaku===0){
                        this.priceStyle['fontSize'] = '0.7rem'
                        total_price = '後幕が製作不可の設定です'
                        this.$store.commit('updatePriceData', {name: 'total_price', value: total_price})
                        return total_price
                    }
                    if(price > 0 && (price_atomaku==='製作不可のサイズです' || price_add==='製作不可のサイズです')){
                        this.priceStyle['fontSize'] = '0.7rem'
                        total_price = '製作不可のサイズです'
                        this.$store.commit('updatePriceData', {name: 'total_price', value: total_price})
                        return total_price
                    }
                    let total_price = price+price_ura+price_add+price_atomaku
                    let price_error = ''
                    this.priceStyle['fontSize'] = '1.6rem'
                    if(price === 0){
                        this.priceStyle['fontSize'] = '0.7rem'
                        total_price = '製作不可のサイズです'
                        let hida = step3_data.hida
                        if(hida==='' || hida === undefined){
                            return total_price
                        }
                        hida = hida.split('/')[0]
                        hida = hida.replace(/約/g,'')
                        if(hida==='1倍'){
                            hida = 'フラット'
                        }
                        else if(hida==='2.3倍'){
                            hida = '2倍ヒダ'
                        }
                        else{
                            hida = hida+'ヒダ'
                        }
                        let open = step3_data.open
                        //開閉不可対策
                        if(open === '開閉不可'){
                            open='片開き';
                        }
                        if(
                            step3_data.size_min_max &&
                            step3_data.size_min_max[hida] &&
                            step3_data.size_min_max[hida][open]
                        )
                        {
                            if (
                                step3_data.width_size < step3_data.size_min_max[hida][open].width_min ||
                                step3_data.width_size > step3_data.size_min_max[hida][open].width_max ||
                                step3_data.height_size < step3_data.size_min_max[hida][open].height_min ||
                                step3_data.height_size > step3_data.size_min_max[hida][open].height_max
                            ) {
                                const price_file = this.$store.state.price_data.price_file
//                                if(price_file.indexOf('SWH') > -1 || price_file.indexOf('SWS') > -1 ||  price_file.indexOf('SWHL') > -1){
                                if(
                                    step2_data.style_selected1_name==='スタンダード縫製' ||
                                    step2_data.style_selected1_name==='ソフトウェーブ縫製'
                                ){
                                    if (
                                        step3_data.width_size > step3_data.size_min_max[hida][open].width_max ||
                                        step3_data.height_size > step3_data.size_min_max[hida][open].height_max
                                    ) {
                                        this.priceStyle['fontSize'] = '0.5rem'
                                        total_price = '価格についてはお問い合わせください'
                                    }
                                }
                            }
                        }
                    }else{
                        total_price = String(total_price).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
                    }
                    this.$store.commit('updatePriceData', {name: 'total_price', value: total_price})
                    return total_price
                },
            },
            suso_options:{
                get:function(){
                    if(this.$store.state.step2_data.style_selected1_id !== '' && this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1 === 'カーテン'){
                        if(this.$store.state.step2_data.style_selected2_id !==''){
                            return this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name]['裾形状を選ぶ↓ヨコ使いレース生地のみ'].option
                        }
                        else if(this.$store.state.step2_data.style_selected1_id !==''){
                            return this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name]['裾形状を選ぶ↓ヨコ使いレース生地のみ'].option
                        }
                        else{
                            return false
                        }
                    }else{
                        return false
                    }
                }
            },
        },
        methods:{
            /**
             * URLが設定されている場合
             * 新規タブでURLをたたく
             */
            styleImaging:function(id){
                let name = this.$store.state.xlsx_data.style_data[id]
                if(this.isset(name.urls)){
                    window.open(name.urls , '_blank');
                }
            },
            /**
             *  値の有無をチェック
             *  phpのisset()に相当
             *  @param  data    値
             *  @return         true / false
             *
             */
            isset : function(data){
                if(data === "" || data === null || data === undefined){
                    return false;
                }else{
                    return true;
                }
            }
        }
    }
</script>

<style scoped>
    .sum_price .price_end {
        font-size: 0.7rem;
    }
    .hidden-xs{
        display: inline-flex;
    }
    @media (min-width: 992px){
        .hidden-xs{
            display: none;
        }
    }
</style>